import { servidor } from "../servidor";

/**
 * Obtiene la lista de todos los productos disponibles para una sucursal y tienda específicas.
 *
 * @async
 * @function getAllProducts
 * @param {string} branch - Identificador de la sucursal.
 * @param {string} store - Identificador de la tienda.
 * @returns {Promise<Array<Object>>} Lista de productos devuelta por el servidor.
 * @throws {Error} Si ocurre un error de red, el servidor responde con un código inesperado,
 *                 o hay un fallo al obtener los datos.
 */
export const getAllProducts = async (branch, store) => {
  try {
    const response = await servidor.get("/movilabs/getAllProducts", {
      params: {
        branch,
        store,
      },
    });
    if (response.status !== 200) {
      throw new Error(`Error: Received status code ${response.status}`);
    }
    // console.log('response', response.data);
    return response.data.allProducts;
  } catch (error) {
    console.error("Error fetching getProducts data:", error);
    throw new Error(
      "Servicio no disponible, inténtalo más tarde.\n" + error.message
    );
  }
};
